import { Box, Typography } from '@mui/material';
import { getRouteApi } from '@tanstack/react-router';
import { Fragment } from 'react';

import { ResultStructureCard } from '@/components/result/ResultStructureCard';
import { ResultStructureSkeleton } from '@/components/result/ResultStructureSkeleton';
import { useRoutes } from '@/hooks/useRoutes';
import { TriasHelper } from '@/modules/TriasHelper';

const routeApi = getRouteApi('/_map');

export function ResultStructuresList() {
  const navigate = routeApi.useNavigate();
  const currentSearch = routeApi.useSearch();
  const route = useRoutes();
  const resultStructures = TriasHelper.getIndividualRouteStructures(route.data);

  if (route.isFetching) {
    return (
      <Box>
        <ResultStructureSkeleton />
        <ResultStructureSkeleton />
      </Box>
    );
  }

  if (!resultStructures?.length) return null;

  return (
    <Fragment>
      <Typography fontWeight={500}>Datum und Uhrzeit</Typography>

      {resultStructures
        .filter((result): result is Exclude<typeof result, undefined> => !!result)
        .map((result, index) => (
          <ResultStructureCard
            key={result.resultId}
            resultStructure={result}
            onClick={async () =>
              navigate({
                to: '/route',
                search: {
                  ...currentSearch,
                  resultIndex: index,
                },
              })
            }
          />
        ))}
    </Fragment>
  );
}
